import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Loader from "../../subComponents/Loader";
import {
  getTasks,
  getTaskTypes,
  addTaskNotes,
  getTaskNotes,
  getSubOrdinates,
  downloadTasks,
} from "../../../actions/userActions/tasks/taskAction";
import { Download } from "lucide-react";
// Add these imports - adjust paths according to your project structure
import { getCities } from "../../../actions/userActions/cityAction";
import { getDoctors } from "../../../actions/userActions/doctorAction";
import { getPracticeLocations } from "../../../actions/userActions/practiceLocationAction";
import chevron_rightIcon from "../../../assets/images/chevron_rightIcon.svg";
import { getEmployeeSubOrdinates } from "../../../actions/userActions/employeeAction";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Redirect } from "react-router-dom";
import moment from "moment";
import IconButton from '@mui/material/IconButton';
import "./Filter.css";
import { Drawer, Tooltip } from "@mui/material";
import { format } from "date-fns";
import { Button, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { getTaskPriorities } from "../../../actions/userActions/taskPriorityAction";
import { SIZE_OF_PAGE } from "../../../actions/types";
import { getTaskStatuses } from "../../../actions/userActions/taskStatusAction";
import CustomButton from "../../subComponents/buttons/CustomButton";
import SearchInput from "../../subComponents/search/SearchInput";
import Heading6Regular from "../../designSystem/Heading6Regular";
import BodySmallMedium from "../../designSystem/BodySmallMedium";
import DynamicTable from "../../reuse_components/DynamicTable";
import ItemsPerPageSelector from "../../subComponents/pagination/ItemsPerPageSelector";
import CustomPagination from "../../subComponents/pagination/CustomPagination";
import CustomFilterSelect from "../../designSystem/CustomFilterSelect";
import GenericFilter, { FilterBar } from "../../subComponents/Filter/GenericFilters";
import LoadingOverlay from "../../loadingOverlay/LoadingOverlay";
import { t } from "../../../locales/translate";
import { PERMISSIONS } from "../../../Permissions";

function Tasks() {
  const [state, setState] = useState({ right: false });
  const [taskNote, setTaskNote] = useState("");
  const [newTaskId, setNewTaskId] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showFilters, setShowFilters] = useState(false);

// Filter states
  const [dateRangeFilter, setDateRangeFilter] = useState('last 7 days');
  const [taskPriorityFilter, setTaskPriorityFilter] = useState('');
  const [taskStatusFilter, setTaskStatusFilter] = useState('');
  const [employeeFilter, setEmployeeFilter] = useState('');
  const [cityFilter, setCityFilter] = useState('');
  const [doctorFilter, setDoctorFilter] = useState('');
  const [practiceLocationFilter, setPracticeLocationFilter] = useState('');
  const [textSearchFilter, setTextSearchFilter] = useState('');
  const [isPlannedFilter, setIsPlannedFilter] = useState(''); // '' = All, 'true' = Planned, 'false' = Unplanned
  const [outOfBoundFilter, setOutOfBoundFilter] = useState(''); // '' = All, 'true' = Out of Bound only
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const [customFromDate, setCustomFromDate] = useState('');
  const [customToDate, setCustomToDate] = useState('');

  // Date state
  const [fromDate, setFromDate] = useState(moment().subtract(7, "days").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));

  const dispatch = useDispatch();
  const history = useHistory();
useEffect(() => {
  const savedFilters = sessionStorage.getItem('taskFilters');
  if (savedFilters) {
    try {
      const filters = JSON.parse(savedFilters);
      setDateRangeFilter(filters.dateRangeFilter || 'last 7 days');
      setTaskPriorityFilter(filters.taskPriorityFilter || '');
      setTaskStatusFilter(filters.taskStatusFilter || '');
      setEmployeeFilter(filters.employeeFilter || '');
      setCityFilter(filters.cityFilter || '');
      setDoctorFilter(filters.doctorFilter || '');
      setPracticeLocationFilter(filters.practiceLocationFilter || '');
      setTextSearchFilter(filters.textSearchFilter || '');
      setIsPlannedFilter(filters.isPlannedFilter || '');
      setOutOfBoundFilter(filters.outOfBoundFilter || '');
      setShowFilters(filters.showFilters || false); // ADD THIS LINE
      
      if (filters.fromDate) setFromDate(filters.fromDate);
      if (filters.toDate) setToDate(filters.toDate);
      if (filters.currentPage) setCurrentPage(filters.currentPage);
      if (filters.itemsPerPage) setItemsPerPage(filters.itemsPerPage);
    } catch (error) {
      console.error('Error loading saved filters:', error);
    }
  }
}, []);

useEffect(() => {
  const filters = {
    dateRangeFilter,
    taskPriorityFilter,
    taskStatusFilter,
    employeeFilter,
    cityFilter,
    doctorFilter,
    practiceLocationFilter,
    textSearchFilter,
    isPlannedFilter,
    outOfBoundFilter,
    fromDate,
    toDate,
    currentPage,
    itemsPerPage,
    showFilters
  };
  sessionStorage.setItem('taskFilters', JSON.stringify(filters));
}, [dateRangeFilter, taskPriorityFilter, taskStatusFilter, employeeFilter, 
    cityFilter, doctorFilter, practiceLocationFilter, textSearchFilter, 
    isPlannedFilter, outOfBoundFilter, fromDate, toDate, currentPage, itemsPerPage, showFilters]);


useEffect(() => {
  
  sessionStorage.setItem('inTasksSection', 'true');
  
  return () => {

    setTimeout(() => {
      const currentPath = window.location.pathname;
      const isTaskRelatedPage = 
        currentPath === '/admin/tasks' ||
        currentPath.includes('/admin/task/view') || 
        currentPath.includes('/admin/AddTasks');
      
      if (!isTaskRelatedPage) {
        sessionStorage.removeItem('taskFilters');
        sessionStorage.removeItem('inTasksSection');
      }
    }, 100);
  };
}, []);
  const [page, setPage] = useState(1);
  const user = JSON.parse(localStorage.getItem("user"));
  const auth = useSelector((state) => state.auth);
  const currentDate = moment();

  const tasks = useSelector((state) => state.tasks_reducer.tasks);
  const totalPages = tasks?.totalPages || 0;
  const totalItems = tasks?.totalCount || 0;
  const taskTypes = useSelector((state) => state.tasks_reducer.taskTypes);
  const taskPriorities = useSelector((state) => state.tasks_reducer.taskPriorities);
  const taskPrioritiesData = taskPriorities && taskPriorities.result;
  const taskStatuses = useSelector((state) => state.task_statuses_reducer.taskStatuses);
  const taskStatusData = taskStatuses && taskStatuses.result;
  const getNotes = useSelector((state) => state.tasks_reducer.taskNotes);
  const employees = useSelector((state) => state.tasks_reducer.subOrdinates);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const cities = useSelector((state) => state.cities_reducer?.cities?.result);
  const doctors = useSelector((state) => state.doctors_reducer?.doctors?.result);
  const practiceLocations = useSelector((state) => state.practiceLocations_reducer?.practiceLocations);
  const isTaskTypeLoading = useSelector((state) => state.tasks_reducer.isTaskTypeLoading);
  const isEmployeesLoading = useSelector((state) => state.employees_reducer.isEmployeesLoading);
  const isTaskPriorityLoading = useSelector((state) => state.tasks_reducer.isTaskPriorityLoading);
  const isTaskStatusLoading = useSelector((state) => state.task_statuses_reducer.isTaskStatusLoading);
  const isTasksLoading = useSelector((state) => state.tasks_reducer.isTasksLoading);
  const isLoading = isTasksLoading || isTaskTypeLoading || isEmployeesLoading || isTaskPriorityLoading;
  useEffect(() => {
    if (auth.isLoggedIn === false && !user) {
      return <Redirect to="/" />;
    }
  });
  const getDefaultFilters = () => ({
    taskType: [],
    taskPriority: taskPriorityFilter ? [taskPriorityFilter] : [],
    taskStatus: taskStatusFilter ? [taskStatusFilter] : [],
    taskAssignee: employeeFilter ? [employeeFilter] : [],
    textSearch: textSearchFilter,
    taskFromDate: fromDate,
    taskToDate: toDate,
    cityId: cityFilter || 0,
    doctorId: doctorFilter || 0,
    practiceLocationId: practiceLocationFilter || 0,
    ...(isPlannedFilter !== '' && { isPlanned: isPlannedFilter === 'true' }),
    ...(outOfBoundFilter !== '' && { outOfBound: outOfBoundFilter === 'true' }),
  });

  const toggleDrawer = (anchor, open, taskId) => (event) => {
    dispatch(getTaskNotes(taskId));
    setNewTaskId(taskId);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const handleCloseDrawer = () => {
    setState({ ...state, right: false });
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleClearAllFilters = () => {
    setDateRangeFilter('last 7 days');
    setTaskPriorityFilter('');
    setTaskStatusFilter('');
    setEmployeeFilter('');
    setCityFilter('');
    setDoctorFilter('');
    setPracticeLocationFilter('');
    setTextSearchFilter('');
    setIsPlannedFilter('');
    setOutOfBoundFilter('');
    setShowCustomDatePicker(false);
    setCustomFromDate('');
    setCustomToDate('');
    setCurrentPage(1);

    // Reset to last 7 days
    const newFromDate = moment().subtract(7, "days").format("YYYY-MM-DD");
    const newToDate = moment().format("YYYY-MM-DD");
    setFromDate(newFromDate);
    setToDate(newToDate);

    // Dispatch with cleared filters
    dispatch(getTasks({
      filter: {
        taskType: [],
        taskPriority: [],
        taskStatus: [],
        taskAssignee: [],
        textSearch: '',
        taskFromDate: newFromDate,
        taskToDate: newToDate,
        cityId: 0,
        doctorId: 0,
        practiceLocationId: 0,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
    sessionStorage.removeItem('taskFilters');
  };

  const handleDateRangeChange = (event) => {
    const value = event.target.value;
    
    if (value === 'custom') {
      setShowCustomDatePicker(true);
      return;
    }
    
    setDateRangeFilter(value);
    setShowCustomDatePicker(false);
    setCurrentPage(1);

    let newFromDate, newToDate;

    switch (value) {
      case 'today':
        newFromDate = moment().format("YYYY-MM-DD");
        newToDate = moment().format("YYYY-MM-DD");
        break;
      case 'yesterday':
        newFromDate = moment().subtract(1, "days").format("YYYY-MM-DD");
        newToDate = moment().subtract(1, "days").format("YYYY-MM-DD");
        break;
      case 'last 7 days':
        newFromDate = moment().subtract(7, "days").format("YYYY-MM-DD");
        newToDate = moment().format("YYYY-MM-DD");
        break;
      case 'last 30 days':
        newFromDate = moment().subtract(30, "days").format("YYYY-MM-DD");
        newToDate = moment().format("YYYY-MM-DD");
        break;
      case 'this month':
        newFromDate = moment().startOf("month").format("YYYY-MM-DD");
        newToDate = moment().endOf("month").format("YYYY-MM-DD");
        break;
      case 'last month':
        newFromDate = moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        newToDate = moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
        break;
      case 'this year':
        newFromDate = moment().startOf("year").format("YYYY-MM-DD");
        newToDate = moment().endOf("year").format("YYYY-MM-DD");
        break;
      case 'last year':
        newFromDate = moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD");
        newToDate = moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD");
        break;
      default:
        newFromDate = moment().subtract(7, "days").format("YYYY-MM-DD");
        newToDate = moment().format("YYYY-MM-DD");
    }

    setFromDate(newFromDate);
    setToDate(newToDate);

    // Dispatch with new date range
    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        taskFromDate: newFromDate,
        taskToDate: newToDate,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleCustomDateApply = () => {
    if (!customFromDate || !customToDate) {
      alert('Please select both from and to dates');
      return;
    }

    setFromDate(customFromDate);
    setToDate(customToDate);
    setDateRangeFilter('custom');
    setShowCustomDatePicker(false);
    setCurrentPage(1);

    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        taskFromDate: customFromDate,
        taskToDate: customToDate,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleTaskPriorityChange = (event) => {
    const value = event.target.value;
    setTaskPriorityFilter(value);
    setCurrentPage(1);

    const priorityIds = value ? [value] : [];
    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        taskPriority: priorityIds,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleTaskStatusChange = (event) => {
    const value = event.target.value;
    setTaskStatusFilter(value);
    setCurrentPage(1);

    const statusIds = value ? [value] : [];
    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        taskStatus: statusIds,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleEmployeeChange = (event) => {
    const value = event.target.value;
    setEmployeeFilter(value);
    setCurrentPage(1);

    const employeeIds = value ? [value] : [];
    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        taskAssignee: employeeIds,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };
  const handleCityChange = (event) => {
    const value = event.target.value;
    setCityFilter(value);
    setCurrentPage(1);

    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        cityId: value || 0,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleDoctorChange = (event) => {
    const value = event.target.value;
    setDoctorFilter(value);
    setCurrentPage(1);

    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        doctorId: value || 0,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handlePracticeLocationChange = (event) => {
    const value = event.target.value;
    setPracticeLocationFilter(value);
    setCurrentPage(1);

    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        practiceLocationId: value || 0,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleSearchChange = (query) => {
    setTextSearchFilter(query);
    setCurrentPage(1);

    dispatch(getTasks({
      filter: {
        ...getDefaultFilters(),
        textSearch: query,
      },
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleIsPlannedChange = (event) => {
    const value = event.target.value;
    setIsPlannedFilter(value);
    setCurrentPage(1);

    const filters = {
      ...getDefaultFilters(),
    };

    // Add isPlanned filter if not 'All'
    if (value !== '') {
      filters.isPlanned = value === 'true';
    }

    dispatch(getTasks({
      filter: filters,
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleOutOfBoundChange = (event) => {
    const value = event.target.value;
    setOutOfBoundFilter(value);
    setCurrentPage(1);

    const filters = {
      ...getDefaultFilters(),
    };

    if (value !== '') {
      filters.outOfBound = value === 'true';
    }

    dispatch(getTasks({
      filter: filters,
      pageNumber: 1,
      pageSize: itemsPerPage,
      employeeId: user.result[0]?.user?.id,
    }));
  };

  const handleItemsPerPageChange = (value) => {
    dispatch(getTasks({
      filter: getDefaultFilters(),
      pageNumber: 1,
      pageSize: value,
      employeeId: user.result[0]?.user?.id,
    }));
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  const addTaskHandler = () => {
    history.push({ pathname: "/admin/AddTasks", taskType: "1" });
  };

  const handleTaskDownload = () => {
    const body = {
      filter: getDefaultFilters(),
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      employeeId: user.result[0].user.id,
    };
    dispatch(downloadTasks(body));
  };

  const handleAddNote = async (taskId) => {
    if (taskNote.trim() !== "") {
      const noteBody = {
        taskId: newTaskId,
        note: taskNote,
        createdDate: new Date().toISOString(),
        createdBy: user.result[0].user.id,
        updatedDate: new Date().toISOString(),
        updatedBy: user.result[0].user.id,
      };

      try {
        dispatch(addTaskNotes(noteBody)).then(() => {
          dispatch(getTaskNotes(newTaskId));
        });
        setTaskNote("");
      } catch (error) {
        console.error("An error occurred while adding or fetching notes:", error);
      }
    } else {
      alert("Please enter a note before adding.");
    }
  };

 
useEffect(() => {
  const body = {
    filter: getDefaultFilters(),
    pageNumber: currentPage,
    pageSize: itemsPerPage,
    employeeId: user.result[0].user.id,
  };

  dispatch(getTasks(body))
    .catch((error) => {
      console.error("Error fetching tasks:", error);
    });
}, [currentPage, itemsPerPage, taskPriorityFilter, taskStatusFilter, 
    employeeFilter, cityFilter, doctorFilter, practiceLocationFilter, 
    textSearchFilter, isPlannedFilter, outOfBoundFilter, fromDate, toDate]);
useEffect(() => {
  const pageNumber = -1;
  dispatch(getTaskPriorities(pageNumber, SIZE_OF_PAGE, searchQuery));
  dispatch(getTaskStatuses(pageNumber, SIZE_OF_PAGE));
  dispatch(getSubOrdinates(user.result[0].user.id, -1, 0, ""));
}, []);
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
       
        await dispatch(getCities({
  filter: { 
    textSearch: "", 
    countryId: 0  
  },
  pageNumber: -1,
  pageSize: 0
}));

        await dispatch(getDoctors({
  pageNumber: -1,
  pageSize: 0,
  textSearch: "",
  cityId: 0,
  practiceLocationId: 0,
  rankId: 0,
  specializationId: 0,
  designationId: 0
}));

        await dispatch(getPracticeLocations({
  filter: { 
    textSearch: "", 
    city: 0 
  },
  pageNumber: -1,
  pageSize: 0
}));
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchDropdownData();
  }, []); 
const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
      case 'created':
        return '#87A2C7';
      case 'in review':
      case 'in-review':
        return '#E1A900';
      case 'in progress':
      case 'in-progress':
        return '#5858D1';
      case 'approved':
        return '#2ECC71';
      case 'completed(doctor-unavailable)':
      case 'completed(visit-complete)':
      case 'completed(refused-to-meet)':
      case 'completed':
        return '#07A74A';
      default:
        return '#6B7280';
    }
};

  const list = (taskId) => {
    return (
      <div
        role="presentation"
        onClick={(event) => {
          event.stopPropagation();
        }}
        onKeyDown={(event) => {
          event.stopPropagation();
        }}
      >
        <div>
          <div className="d-flex justify-content-between align-items-center mr-3">
            <p className="heading_notes p-5">Notes</p>
            <Tooltip title="Close Notes" arrow enterDelay={500}>
              <CloseIcon style={{ cursor: "pointer" }} onClick={handleCloseDrawer} />
            </Tooltip>
          </div>
          <hr />
          {getNotes === "isLoading" && <Loader colored={true} />}

          {getNotes !== "isLoading" &&
            getNotes !== undefined &&
            getNotes?.map((noteItem) => {
              const nameParts = noteItem.createdByName.split(" ");
              const firstNameInitial = nameParts[0] ? nameParts[0][0] : "";
              const lastNameInitial =
                nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : "";

              const formattedDate = format(new Date(noteItem.createdDate), "EEEE MMMM d, yyyy");

              return (
                <div key={noteItem.id} style={{ marginTop: "40px", marginBottom: "53px" }}>
                  <div className="notes-avatar-wrapper" id="navbardrop">
                    <p>
                      {firstNameInitial}
                      {lastNameInitial}
                    </p>
                  </div>
                  <div style={{ marginLeft: "67px", marginTop: "-49px" }}>
                    <p className="no-line-break notes_name">{noteItem.createdByName}</p>
                    <p>{formattedDate}</p>
                  </div>
                  <p className="notes_paragraph" style={{ marginBottom: "35px" }}>
                    {noteItem.note}
                  </p>
                </div>
              );
            })}

          <div
            style={{
              position: "fixed",
              bottom: "0px",
              width: "100%",
              backgroundColor: "white",
              zIndex: "999",
            }}
          >
            <TextField
              style={{ width: "28%", margin: "10px" }}
              multiline
              rows={3}
              value={taskNote}
              onChange={(e) => setTaskNote(e.target.value)}
              placeholder="Enter Task Note"
            />
            <br />
            <Button
              style={{
                width: "28%",
                margin: "9px",
                background: "#002D72",
                border: "1px solid #002D72",
                boxShadow: "2px #0000000B",
                color: "white",
              }}
              onClick={() => {
                handleAddNote(taskId);
              }}
            >
              + Add Note
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const taskColumns = [
    { label: `${t("title")}`, accessor: "title" },
    { label: `${t("assignedTo")}`, accessor: "assigneeName" },
    { label: `${t("status")}`, accessor: "taskStatusName" },
    { label: `${t("taskPriority")}`, accessor: "taskPriorityName" },
    { label: `${t("lastUpdated")}`, accessor: "lastUpdateStatusTime" },
  ];

  const transformedTasks =
    tasks !== "isLoading" &&
    tasks?.length !== 0 &&
    tasks?.result?.length !== 0 &&
    tasks?.result?.map((task) => ({
      ...task,
       taskStatusName: (
      <span style={{display: "flex", gap: "8px", alignItems: "center"}}>
        <span style={{ height: "8px", width: "8px", borderRadius: "50%", backgroundColor:getStatusColor(task.taskStatusName) }}></span>
        <span style={{ color: getStatusColor(task.taskStatusName) }}>
        {task.taskStatusName}
      </span>
      </span>
    ),
    lastUpdateStatusTime: moment(task.lastUpdateStatusTime).format("ddd, MMM D, YYYY"),
  }));

  const handleEditTask = (row) => {
    history.push({
      pathname: `/admin/task/view`,
      task: { row },
      state: { id: row.taskId },
    });
  };

  const actions = [
    {
      label: "View Task",
      icon: <RemoveRedEyeOutlinedIcon sx={{ color: '#007B4E' }}/>,
      permission: PERMISSIONS.CAN_VIEW_TASK,
      handler: handleEditTask,
    },
  ];

  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading} />
        <div className="main-container">
          <div className="content-wrapper p-0">
            {/* Header with Search, Pagination, Filter Toggle, and Add Button */}
            <div  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',padding:'20px 16px'}}>
              <div className="task-header-left">
                <SearchInput
                  placeholder={t("search")}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  value={textSearchFilter}
                />
              </div>

              <div className="task-header-right" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ minWidth: '80px' }}>
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>

                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(currentPage) => setCurrentPage(currentPage)}
                />

                <div style={{ paddingRight: '0px' }}>
                  <IconButton onClick={handleTaskDownload}>
                    <Download />
                  </IconButton>
                </div>

                <GenericFilter showFilters={showFilters} toggleFilters={toggleFilters} />

                {permissions && permissions.includes("CanAddTask") && (
                  <CustomButton text={t("addNew")} onClick={addTaskHandler} />
                )}
              </div>
            </div>

           {/* Filter Bar using Generic Filter Component */}
<FilterBar showFilters={showFilters} onClearAll={handleClearAllFilters}>
  <div style={{ 
    display: 'flex', 
    flexWrap: 'nowrap', 
    gap: '12px', 
    alignItems: 'center',
    width: '100%'
    
  }}>
    {/* Date Range Filter */}
    <div style={{ position: 'relative', minWidth: '120px', flexShrink: 0 }}>
      <CustomFilterSelect
        label="Date Range"
        width="120px"
        value={dateRangeFilter}
        searchable={false}
        onChange={handleDateRangeChange}
        options={[
          { id: 'today', name: 'Today' },
          { id: 'yesterday', name: 'Yesterday' },
          { id: 'last 7 days', name: 'Last 7 Days' },
          { id: 'last 30 days', name: 'Last 30 Days' },
          { id: 'this month', name: 'This Month' },
          { id: 'last month', name: 'Last Month' },
          { id: 'this year', name: 'This Year' },
          { id: 'last year', name: 'Last Year' },
          { id: 'custom', name: 'Custom Range...' },
        ]}
      />
      
      {/* Custom Date Picker Popup */}
      {showCustomDatePicker && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          zIndex: 1000,
          backgroundColor: 'white',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '16px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          minWidth: '300px',
          marginTop: '4px'
        }}>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>From Date</label>
            <input
              type="date"
              value={customFromDate}
              onChange={(e) => setCustomFromDate(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>To Date</label>
            <input
              type="date"
              value={customToDate}
              onChange={(e) => setCustomToDate(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => {
                setShowCustomDatePicker(false);
                setCustomFromDate('');
                setCustomToDate('');
              }}
              style={{
                padding: '6px 12px',
                fontSize: '14px',
                textTransform: 'none'
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleCustomDateApply}
              variant="contained"
              style={{
                padding: '6px 12px',
                fontSize: '14px',
                textTransform: 'none',
                backgroundColor: '#002D72'
              }}
            >
              Apply
            </Button>
          </div>
        </div>
      )}
    </div>

    {/* City Filter */}
    <div style={{ minWidth: '110px', flexShrink: 0 }}>
      <CustomFilterSelect
        label="City"
        width="110px"
        value={cityFilter}
        searchPlaceholder="Search city"
        onChange={handleCityChange}
        options={[
          { id: '', name: 'All' },
          ...(Array.isArray(cities)
            ? cities
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(city => ({
                id: city.id,
                name: city.name
              }))
            : [])
        ]}
      />
    </div>

    {/* Task Status Filter */}
    <div style={{ minWidth: '110px', flexShrink: 0 }}>
      <CustomFilterSelect
        label={t("status")}
        width="110px"
        value={taskStatusFilter}
        searchPlaceholder="Search status"
        onChange={handleTaskStatusChange}
        options={[
          { id: '', name: 'All' },
          ...(Array.isArray(taskStatusData)
            ? taskStatusData
              .filter((status) => status.active)
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(status => ({
                id: status.id,
                name: status.name
              }))
            : [])
        ]}
      />
    </div>

    {/* Employee Filter */}
    <div style={{ minWidth: '115px', flexShrink: 0 }}>
      <CustomFilterSelect
        label={t("employee")}
        width="115px"
        value={employeeFilter}
        searchPlaceholder="Search employee"
        onChange={handleEmployeeChange}
        options={[
          { id: '', name: 'All' },
          ...(Array.isArray(employees)
            ? employees
              .sort((a, b) => a.firstName.localeCompare(b.firstName) || a.lastName.localeCompare(b.lastName))
              .map(employee => ({
                id: employee.id,
                name: `${employee.firstName} ${employee.lastName}`
              }))
            : [])
        ]}
      />
    </div>

    {/* Doctor Filter */}
    <div style={{ minWidth: '110px', flexShrink: 0 }}>
      <CustomFilterSelect
        label="Doctor"
        width="110px"
        value={doctorFilter}
        searchPlaceholder="Search doctor"
        onChange={handleDoctorChange}
        options={[
          { id: '', name: 'All' },
          ...(Array.isArray(doctors)
            ? doctors
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(doctor => ({
                id: doctor.id,
                name: doctor.name
              }))
            : [])
        ]}
      />
    </div>

    {/* Practice Location Filter */}
    <div style={{ minWidth: '125px', flexShrink: 0 }}>
      <CustomFilterSelect
        label="Practice Loc..."
        width="125px"
        value={practiceLocationFilter}
        searchPlaceholder="Search location"
        onChange={handlePracticeLocationChange}
        options={[
          { id: '', name: 'All' },
          ...(Array.isArray(practiceLocations?.result)
    ? practiceLocations.result
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(location => ({
        id: location.id,
        name: location.name
      }))
    : [])
        ]}
      />
    </div>

    {/* Visit Type Filter (Planned/Unplanned) */}
    <div style={{ minWidth: '120px', flexShrink: 0 }}>
      <CustomFilterSelect
        label="Visit Type"
        width="120px"
        value={isPlannedFilter}
        searchable={false}
        onChange={handleIsPlannedChange}
        options={[
          { id: '', name: 'All' },
          { id: 'true', name: 'Planned Visit' },
          { id: 'false', name: 'Unplanned Visit' }
        ]}
      />
    </div>

    {/* Out of Bound Filter */}
    <div style={{ minWidth: '130px', flexShrink: 0 }}>
      <CustomFilterSelect
        label="Out of Bound"
        width="130px"
        value={outOfBoundFilter}
        searchable={false}
        onChange={handleOutOfBoundChange}
        options={[
          { id: '', name: 'All' },
          { id: 'true', name: 'Out of Bound' },
        ]}
      />
    </div>
  </div>
</FilterBar>


          </div>
          <DynamicTable
            data={transformedTasks || []}
            columns={taskColumns}
            permissions={permissions}
            actions={actions}
            showPagination={totalItems > 0}
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={(currentPage) => setCurrentPage(currentPage)}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>

        {/* Drawer for Notes */}
        <Drawer anchor="right" open={state.right} onClose={handleCloseDrawer}>
          {list()}
        </Drawer>
      </div>
    </>
  );
}

export default Tasks;